<template>
  <div v-if="showAd && notEmptyAd"
       id="wegow-ads-dynamic"
       :class="{'fix-box': fixBox,
                'fix-box-110': verticalPosition === 110,
                'fix-box-160': verticalPosition === 160,
                'fix-box-240': verticalPosition === 240,
                'small-box': smallBox,
                'close-box': closeBox,
                'big-box': bigBox,
                'video-in-banner': videoInBanner,
                'expand-video': expandVideo,
                'hide-ad': hideAd}"
       class="wegow-ads-dynamic">
    <div class="wegow-ads-dynamic-container"
         @mouseover="smallBox=false"
         @mouseout="smallBox=true">
      <wegow-ads class="desktop-event-dynamic"
                 :values="values"
                 adstype="wegow-web-dynamic-ad"
                 @emptySliderAds="notEmptyAd=false" />
      <p class="desktop-event-dynamic-small-text">WegowAds</p>
      <span class="close-arrow"
            @click="closeAd" />
    </div>
    <div class="wegow-ads-close-arrow"
         @click="closeBox = !closeBox" />
    <div v-if="modalVideo"
         class="modalVideoAds">
      <span class="modal-close-arrow"
            @click="closeVideoModal" />
      <div class="video-modal">
        <video-player v-if="videoPlayerExists"
                      :options="playerOptions"
                      class="video-player-box" />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import WegowAds from './WegowAds.vue'

export default {
  components: {
    WegowAds
  },
  props: {
    values: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    fixBox: false,
    smallBox: false,
    closeBox: false,
    bigBox: true,
    videoInBanner: false,
    expandVideo: false,
    modalVideo: false,
    hideAd: false,
    verticalPosition: 0,
    playerOptions: {},
    showAd: true,
    notEmptyAd: true,
    videoPlayerExists: false
  }),
  async mounted() {
    // if (!this.values.id)
    //   this.values.id = `wegow-ads-container-${parseInt(Math.random() * 1000)}`
    this.showAd = true
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener(
      'message',
      event => {
        if (event.data && event.data.video_in_banner) {
          this.openVideoInBanner(event)
        } else if (event.data && event.data.event === 'expandVideo') {
          this.openExpandVideo(event)
        } else if (event.data && event.data.event === 'collapseVideo') {
          this.collapseVideo(event)
        } else if (event.data && event.data.video_url_mp4) {
          this.openVideoModal(event.data)
        }
      },
      false
    )
    this.handleScroll()

    if (typeof this.$loadScript === 'function') {
      await this.$loadScript(
        'https://cdn.jsdelivr.net/npm/vue-video-player@5.0.0/dist/vue-video-player.js'
      ).then(() => {
        this.$options.components.videoPlayer = Vue.component(
          'videoPlayer',
          window.videoPlayer
        )
        this.videoPlayerExists = true
      })
    }
  },
  methods: {
    handleScroll() {
      var thereIsHeader = document.getElementsByTagName('header')[0]
        ? document
          .getElementsByTagName('header')[0]
          .className.includes('fadeIn')
        : false
      var thereIsBuyBanner = document.getElementById('buy-banner')
        ? document.getElementById('buy-banner').className.includes('fadeIn')
        : false

      if (thereIsHeader && !thereIsBuyBanner) {
        this.verticalPosition = 110
      } else if (!thereIsHeader && thereIsBuyBanner) {
        this.verticalPosition = 160
      } else if (thereIsHeader && thereIsBuyBanner) {
        this.verticalPosition = 240
      } else {
        this.verticalPosition = 110
      }
      if (window.scrollY > 290 || (window.scrollY > 62 && this.videoInBanner)) {
        this.fixBox = true
        if (!this.videoInBanner) {
          this.bigBox = false
          this.smallBox = true
        } else {
          this.bigBox = true
          this.smallBox = false
        }
      } else {
        this.fixBox = false
        this.bigBox = true
        this.smallBox = false
      }
    },
    openVideoInBanner(event) {
      if (event.data.video_in_banner_open) {
        this.videoInBanner = true
      } else {
        this.videoInBanner = false
      }
      this.handleScroll()
    },
    openExpandVideo(event) {
      this.expandVideo = true
    },
    collapseVideo(event) {
      this.expandVideo = false
    },
    openVideoModal(data) {
      this.modalVideo = true
      this.playerOptions = {
        autoplay: true,
        language: 'en',
        fluid: true,
        sources: [
          {
            type: 'video/mp4',
            src: data.video_url_mp4
          }
        ]
      }
    },
    closeVideoModal(data) {
      this.modalVideo = false
      this.playerOptions = {}
    },
    closeAd() {
      this.hideAd = true
      this.$root.$emit('hidedynamicAd')
    }
  },
  head() {
    return {
      link: [
        { rel: 'stylesheet', href: 'https://vjs.zencdn.net/7.6.6/video-js.css' }
      ]
    }
  }
}
</script>

<style lang="scss">
@import './styles/dynamic-ads.sass';
</style>


<style lang="css">
@import './styles/dynamic-ads-videos.css';
</style>

